import type { Guide } from '../types';

/**
 * S-26.10-05 — kolejka raportów dla klientów, podgląd „plan / potwierdzone”, plik i szkic maila (scenariusz e2e 35;
 * makieta p. Mariusza, ekrany 7–8, BR-CS-01, ścieżki CS-02 i CS-05). Raport „DEMO Plan dostaw tygodniowy” przygotowuje
 * `scenario-state.mjs`.
 */
export const guide: Guide = {
  flagKey: 'clientReportQueue',
  title: 'Raporty dla klientów: kolejka, podgląd „plan / potwierdzone”, plik i szkic maila',
  whatItDoes:
    'Raporty dla klientów powstają z harmonogramu konfiguracji albo przyciskiem „Przygotuj teraz” i czekają w kolejce według terminu. Podgląd odróżnia terminy planowane od potwierdzonych w realizacji i oznacza braki. CS pobiera plik Excel albo CSV, otwiera gotową wiadomość w swojej poczcie albo kopiuje jej treść, wysyła ją sam i oznacza raport jako wysłany. Raport można wstrzymać z powodem. Z systemu nic nie jest wysyłane.',
  audience: ['CS', 'Team Leader CS', 'administrator'],
  presentationItems: ['S-26.10-05'],
  steps: [
    {
      route: '/client-reports',
      target: 'client-reports',
      title: 'Kolejka raportów',
      description:
        'Raporty według terminu ze stanem: do przygotowania, niekompletny, do akceptacji, wysłany ręcznie, wstrzymany. Raport, którego termin minął, ma oznaczenie „po terminie”.',
      action: 'Otwórz w menu „Raporty dla klientów”.',
      recorder: { account: 'cs' },
    },
    {
      route: '/client-reports',
      target: 'client-report-rows',
      title: 'Plan czy potwierdzone',
      description:
        'Przy każdym terminie oznaczenie „plan” albo „potwierdzone” — potwierdzone podaje TMS w realizacji. Braki są na czerwono; punkty wewnętrzne planowania nie trafiają do raportu.',
      action: 'Kliknij raport w kolejce.',
      recorder: { account: 'cs', actions: [{ kind: 'click', target: 'client-report-item-*' }] },
    },
    {
      route: '/client-reports',
      target: 'client-report-draft',
      title: 'Plik i szkic wiadomości',
      description:
        'Plik do pobrania (Excel albo CSV) i gotowa wiadomość z tematem i treścią: „Otwórz w poczcie” albo „Kopiuj treść”. Wysyłasz samodzielnie, z plikiem jako załącznikiem.',
      action: 'Kliknij „Pobierz Excel”, potem „Otwórz w poczcie”.',
      recorder: { account: 'cs', actions: [{ kind: 'click', target: 'client-report-item-*' }] },
    },
    {
      route: '/client-reports',
      target: 'cs-raport-akceptuj-wyslij',
      mockupTestId: 'cs-raport-akceptuj-wyslij',
      title: 'Wysłane ręcznie',
      description:
        'Po wysłaniu oznacz raport jako wysłany — w historii zostaje kto, kiedy i do kogo. Raport z brakami wymaga potwierdzenia, że wyszedł z oznaczonymi brakami. „Wstrzymaj” — z powodem.',
      action: 'Zaznacz potwierdzenie braków (jeśli są) i kliknij przycisk oznaczenia wysyłki.',
      recorder: { account: 'cs', actions: [{ kind: 'click', target: 'client-report-item-*' }] },
    },
    {
      route: '/client-reports',
      target: 'client-report-history',
      title: 'Historia raportu',
      description: 'Kto przygotował raport, pobrał plik, wstrzymał go, wznowił i oznaczył jako wysłany.',
      action: 'Przewiń podgląd raportu do „Historia raportu”.',
      recorder: { account: 'cs', actions: [{ kind: 'click', target: 'client-report-item-*' }] },
    },
  ],
};
